// extracted by mini-css-extract-plugin
export default {"div":"CartStatus_div__kZccG","cartIcon":"CartStatus_cartIcon__e8aSV","count":"CartStatus_count__fWqm0"};